import {
  BaseReducerState,
  UpdateOneDayDiscountResponse,
} from '../../../services'
import { ActionTypes } from '../actions'

export type OneDayDiscountState = BaseReducerState & {
  data: null
}

const updateOneDayDiscountInitialState: OneDayDiscountState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const updateOneDayDiscount = (
  state: OneDayDiscountState = updateOneDayDiscountInitialState,
  action: { type: string; res: any }
): OneDayDiscountState => {
  switch (action.type) {
    case `${ActionTypes.UPDATE_ONE_DAY_DISCOUNT_CATEGORIES}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.UPDATE_ONE_DAY_DISCOUNT_CATEGORIES}_SUCCESS`: {
      const { success, data, message } = <UpdateOneDayDiscountResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
      }
    }
    case `${ActionTypes.UPDATE_ONE_DAY_DISCOUNT_CATEGORIES}_FAILURE`:
      const res = <UpdateOneDayDiscountResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.UPDATE_ONE_DAY_DISCOUNT_CATEGORIES}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
